import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

class IsAdmin extends PureComponent {
	// componentDidMount() {
	// 	// Checks if the user is authenticated
	// 	// This will also update the Redux store if there is an active session
	// 	this.props.dispatch(checkIsLoggedIn());
	// }

	render() {
		const { isTrue, isFalse, isLoggedIn, isAdmin } = this.props;

		if (isLoggedIn && isAdmin) {
			return <React.Fragment>{isTrue}</React.Fragment>;
		} else {
			return <React.Fragment>{isFalse}</React.Fragment>;
		}
	}
}

// PropTypes
IsAdmin.defaultProps = {
	isLoggedIn: false,
	isAdmin: false,
};

IsAdmin.propTypes = {
	isLoggedIn: PropTypes.bool,
	isAdmin: PropTypes.bool,
	isTrue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	isFalse: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

function mapStateToProps(state) {
	return {
		isLoggedIn: state.authentication.isLoggedIn,
		isAdmin: state.authentication.profile.admin,
	};
}

export default connect(mapStateToProps)(IsAdmin);



// WEBPACK FOOTER //
// ./src/components/general/restricted/is-admin/index.jsx